export function objectToQueryParams<T extends Record<string, unknown>>(obj: T): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(obj)) {
    if (typeof value !== 'undefined' && value !== null) {
      params.append(key, String(value));
    }
  }
  return params.toString();
}
